<app-modal-header>
  <div class="flex w-full items-center justify-between">
    <div class="flex items-center">
      <svg-icon [src]="'icon-megaphone-2' | icon" class="my-1 w-8 text-modules-school-500"></svg-icon>
      <div class="ml-2 text-lg font-semibold text-modules-school-500" translate>comunicados.titulo-modal-novo</div>
    </div>
  </div>
</app-modal-header>

<div app-modal-content class="z-0 h-[90vh] w-[90vw] bg-white p-0!">
  <form [formGroup]="form" class="flex h-full flex-col">
    <div class="no-scrollbar flex flex-grow flex-col overflow-y-auto md:overflow-y-hidden">
      <div class="flex shrink-0 flex-col gap-3 px-8 pt-4 pb-3">
        <div class="flex w-full flex-col gap-4 md:flex-row">
          <app-form-field class="w-full flex-1">
            <label app-label translate>comunicados.titulo-comunicado</label>
            <input app-input maxlength="100" formControlName="title" />
          </app-form-field>

          <app-form-field class="w-full shrink-0 md:w-32">
            <label app-label translate>comunicados.numero</label>
            <input app-input formControlName="code" />
          </app-form-field>
        </div>

        <div class="flex w-full flex-col items-start gap-4 md:flex-row">
          @if (academicPeriod$ | async; as academicPeriod) {
            <app-form-field class="w-full shrink-0 md:w-44">
              <label app-label translate>comunicados.data</label>
              <app-input-datepicker
                [minDate]="academicPeriod?.start"
                [maxDate]="academicPeriod?.end"
                formControlName="date"
              />
            </app-form-field>
          }

          <app-form-field class="w-full flex-1">
            <label app-label translate>comunicados.autor</label>
            <input app-input maxlength="60" formControlName="author" />
          </app-form-field>
        </div>

        <div class="flex w-full flex-col gap-3 p-0">
          <div class="flex w-full flex-col items-start justify-between gap-2 md:flex-row md:items-center">
            <div class="text-[10px] font-bold uppercase tracking-widest text-gray-400" translate>
              comunicados.publico-alvo
            </div>
            <div class="flex items-center gap-3">
              <span
                class="text-sm font-semibold"
                [ngClass]="{
                  'text-modules-school-600': !form.value.specificStudents,
                  'text-gray-400': form.value.specificStudents,
                }"
                translate
              >
                comunicados.por-grupos
              </span>
              <app-switch colorTrue="bg-modules-school-500" formControlName="specificStudents"></app-switch>
              <span
                class="text-sm font-semibold"
                [ngClass]="{
                  'text-modules-school-600': form.value.specificStudents,
                  'text-gray-400': !form.value.specificStudents,
                }"
                translate
              >
                comunicados.por-alunos
              </span>
            </div>
          </div>

          @if (!form.value.specificStudents) {
            <app-form-field class="w-full">
              <label app-label translate>comunicados.grupos</label>
              <ng-select
                app-select
                formControlName="groupings"
                [items]="group$ | async"
                bindLabel="descricao"
                bindValue="id"
                [multiple]="true"
                [closeOnSelect]="false"
                [clearable]="false"
              >
                <ng-template ng-multi-label-tmp let-items="items">
                  <div class="ng-value border-none! bg-transparent! p-0!">
                    <span class="text-sm font-semibold text-modules-school-600">
                      {{ items.length }}
                      {{
                        (items.length === 1 ? 'comunicados.grupo-selecionado' : 'comunicados.grupos-selecionados')
                          | translate
                      }}
                    </span>
                  </div>
                </ng-template>
              </ng-select>
            </app-form-field>
          } @else {
            <div class="flex w-full flex-col gap-4 md:flex-row">
              <app-form-field class="w-full shrink-0 md:w-64">
                <label app-label translate>geral.turma</label>
                <ng-select
                  app-select
                  formControlName="groupFilter"
                  [items]="schoolGroups$ | async"
                  bindLabel="name"
                  bindValue="id"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [clearable]="true"
                  [searchable]="true"
                  [notFoundText]="'geral.nenhum-dado' | translate"
                  [placeholder]="'geral.selecionar-turma' | translate"
                >
                  <ng-template ng-multi-label-tmp let-items="items">
                    <div class="ng-value border-none! bg-transparent! p-0!">
                      <span class="text-sm font-semibold text-modules-school-600">
                        {{ items.length }}
                        {{
                          (items.length === 1 ? 'comunicados.turma-selecionada' : 'comunicados.turmas-selecionadas')
                            | translate
                        }}
                      </span>
                    </div>
                  </ng-template>
                </ng-select>
              </app-form-field>

              <app-form-field class="w-full flex-1">
                <label app-label translate>comunicados.alunos</label>
                <ng-select
                  app-select
                  formControlName="users"
                  [items]="students$ | async"
                  bindLabel="name"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [clearable]="false"
                  [searchable]="true"
                  [disabled]="!form.value.groupFilter?.length"
                  [compareWith]="compareStudents"
                  [notFoundText]="'geral.nenhum-dado' | translate"
                  [placeholder]="
                    form.value.groupFilter?.length ? ('geral.selecionar-aluno' | translate) : 'Selecione a turma antes'
                  "
                >
                  <ng-template ng-multi-label-tmp let-items="items">
                    <div class="ng-value border-none! bg-transparent! p-0!">
                      <span class="text-sm font-semibold text-modules-school-600">
                        {{ items.length }}
                        {{
                          (items.length === 1 ? 'comunicados.aluno-selecionado' : 'comunicados.alunos-selecionados')
                            | translate
                        }}
                      </span>
                    </div>
                  </ng-template>
                </ng-select>
              </app-form-field>
            </div>
          }
        </div>
      </div>

      <div class="no-scrollbar flex grow flex-col gap-6 overflow-y-visible p-8 pt-0 md:overflow-y-auto">
        <div class="flex flex-col gap-6">
          <app-form-field class="w-full">
            <label app-label translate>comunicados.descricao</label>
            <app-text-editor
              formControlName="description"
              [url]="ckeditorUploadImageUrl"
              class="mt-2"
            ></app-text-editor>
          </app-form-field>

          @if (!form.value.specificStudents) {
            @if (allGroups$ | async; as groups) {
              @if (getSelectedGroups(groups); as selectedGroups) {
                @if (selectedGroups.length) {
                  <div class="flex flex-col gap-2">
                    <label app-label translate class="text-[10px] font-bold uppercase tracking-widest text-gray-400">
                      comunicados.grupos-selecionados
                    </label>
                    <div class="flex flex-wrap gap-2">
                      @for (group of selectedGroups; track group.id) {
                        <span
                          class="flex items-center gap-2 rounded-full border border-modules-school-100 bg-modules-school-50 px-3 py-1 text-xs font-semibold text-modules-school-700"
                        >
                          {{ group.descricao }}
                          <svg-icon
                            (click)="onRemoveGroup(group.id)"
                            src="assets/icons/icon-close.svg"
                            class="h-3 w-3 cursor-pointer transition-colors hover:text-modules-school-900"
                          ></svg-icon>
                        </span>
                      }
                    </div>
                  </div>
                }
              }
            }
          }

          @if (form.value.specificStudents) {
            @if (form.value.users?.length) {
              <div class="flex flex-col gap-2">
                <label
                  app-label
                  translate
                  class="text-[10px] font-bold uppercase tracking-widest text-gray-400"
                  translate
                >
                  comunicados.alunos-selecionados
                </label>
                <div class="flex flex-wrap gap-2">
                  @for (student of form.value.users; track student.user_id) {
                    <span
                      class="flex items-center gap-2 rounded-full border border-modules-school-100 bg-modules-school-50 px-3 py-1 text-xs font-semibold text-modules-school-700"
                    >
                      {{ student.name }}
                      <svg-icon
                        (click)="onRemoveStudent(student.user_id)"
                        src="assets/icons/icon-close.svg"
                        class="h-3 w-3 cursor-pointer transition-colors hover:text-modules-school-900"
                      ></svg-icon>
                    </span>
                  }
                </div>
              </div>
            }
          }

          <app-form-field class="w-full">
            <label app-label translate>eclass.arquivos</label>
            <div class="mt-2">
              <app-attachment-dropzone
                [maxSizeMB]="50"
                [accept]="'.pdf,.mp3,.mp4,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.txt'"
                [multiple]="true"
                [maxFiles]="10"
                folder="communications"
                [initialAttachments]="existingAttachments"
                (uploadComplete)="onUploaded($event)"
                (filesChanged)="onFilesChanged($event)"
                (removeExisting)="onFileRemoved($event)"
              />
            </div>
          </app-form-field>
        </div>
      </div>
    </div>

    <div class="shrink-0 rounded-b-lg border-t border-gray-100 bg-white p-8 pt-4">
      <div class="flex flex-row justify-between px-2 pt-3">
        <button
          (click)="onCancel()"
          app-outline-button
          class="border-modules-school-500 px-5 uppercase text-modules-school-500 enabled:hover:bg-modules-school-600 enabled:hover:text-white"
          translate
        >
          geral.cancelar
        </button>
        <div class="flex flex-row items-center justify-end gap-4 p-0">
          @if (!form.value.id) {
            <div class="flex flex-row items-center justify-end gap-2 p-0">
              <app-switch
                colorTrue="bg-modules-school-500"
                [formControl]="sendMailCtrl"
                app-tooltip
                [tooltip]="'comunicados.enviar-por-email-info' | translate"
              ></app-switch>
              <span class="text-sm" translate> comunicados.enviar-por-email </span>
            </div>
          }
          <button
            app-flat-button
            class="bg-modules-school-500 px-5 uppercase text-white transition-all hover:bg-modules-school-600"
            (click)="onSave()"
            [disabled]="!!disable || loading()"
            translate
          >
            {{ (loading() ? 'eclass.tarefa.salvando' : 'geral.salvar') | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
